import { useCallback, useLayoutEffect, useState } from "react";

import { useResizeObserver } from "@/utils/useResizeObserver";

/**
 * Whether the element's content is wider than the element, i.e. it scrolls horizontally.
 * The content is expected to be the element's first child.
 */
export function useHasHorizontalOverflow(element: HTMLElement | null): boolean {
  const [hasOverflow, setHasOverflow] = useState(false);

  const measure = useCallback(() => {
    if (element) {
      setHasOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [element]);

  useLayoutEffect(() => measure(), [measure]);
  useResizeObserver(element, measure);
  useResizeObserver(element?.firstElementChild ?? null, measure);

  return hasOverflow;
}
